import { Input, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';

const PREFIX = 'SearchPanelInput';

export const classes = {
	root: `${PREFIX}-root`,
};

const StyledInput = styled(Input)(({ theme }) => ({
	[`&.${classes.root}`]: {
		display: 'flex',
		alignItems: 'center',
	},
}));

export const DevExpressSearchPanelInput = ({
	onValueChange, value, inputRef, ...restProps
}) => (
	<StyledInput
		className={classes.root}
		inputRef={inputRef} //ref={inputRef}
		onChange={e => onValueChange(e.target.value)}
		value={value}
		type="text"
		placeholder="Search..."
		{...restProps}
		startAdornment={(
			<InputAdornment position="start">
				<SearchIcon />
			</InputAdornment>
		)}
	/>
);
